module.exports = __webpack_public_path__ + "static/greatwyrm_blue-68c536502ddd6f604bda1c406e9fdef2.webp";